export default __webpack_public_path__ + "static/media/swissmom-logo-white.80dedd32.png";